import { render, staticRenderFns } from "./AdminEbEdit.vue?vue&type=template&id=685b95e6&scoped=true"
import script from "./AdminEbEdit.vue?vue&type=script&lang=js"
export * from "./AdminEbEdit.vue?vue&type=script&lang=js"
import style0 from "./AdminEbEdit.vue?vue&type=style&index=0&id=685b95e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685b95e6",
  null
  
)

export default component.exports